module.exports = __webpack_public_path__ + "img/logo-chrome.3505b424.png";